import Vue from 'vue'
import Router from 'vue-router'
import { clearLoginInfo } from '@/utils'
Vue.use(Router)


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  // mode: "history",
  // 解决vue框架页面跳转有白色不可追踪色块的bug
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: '/',
      component: resolve => require(['@/view/main'], resolve),
      redirect: { name: 'home' },
      meta: { title: '主入口' },
      children: [{
        path: '/home',
        name: 'home',
        component: resolve => require(['@/view/home/homePage'], resolve),
        meta: {
          title: '首页'
        }
      }, {
        path: '/uploading',
        name: 'uploading',
        component: resolve => require(['@/view/uploading/uploading'], resolve),
        meta: {
          title: '上传作品'
        }
      }, {
        path: '/userCenter',
        name: 'userCenter',
        component: resolve => require(['@/view/userCenter/userCenter'], resolve),
        meta: {
          title: '个人中心'
        }
      }, {
        path: '/WorkManage',
        name: 'WorkManage',
        component: resolve => require(['@/view/userCenter/WorkManage'], resolve),
        meta: {
          title: '作品管理'
        }
      }, {
        path: '/detail',
        name: 'detail',
        component: resolve => require(['@/view/detail/detail'], resolve),
        meta: {
          title: '节目详情'
        }
      }, {
        path: '/workAlter',
        name: 'workAlter',
        component: resolve => require(['@/view/workAlter/workAlter'], resolve),
        meta: {
          title: '作品修改'
        }
      }, {
        path: '/artistDetail',
        name: 'artistDetail',
        component: resolve => require(['@/view/artistDetail/artistDetail'], resolve),
        meta: {
          title: '艺术家详情'
        }
      }],
      beforeEnter (to, from, next) {
        let token = Vue.cookie.get('Token')
        if (to.name == 'detail') {
          next()
        } else {

          if (!token || !/\S/.test(token)) {
            clearLoginInfo()
            next({ name: 'login' })
          }

          next()
        }
      }
    }, {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/view/common/login'], resolve),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/registr',
      name: 'registr',
      component: resolve => require(['@/view/common/registr'], resolve),
      meta: {
        title: '注册'
      }
    }, {
      path: '/forget',
      name: 'forget',
      component: resolve => require(['@/view/common/forget'], resolve),
      meta: {
        title: '忘记密码'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js